<template>
    <div id="InboxContainer">
        <div id="TitleBar">
            <span id="PageTitle">Inbox</span>
            <div id="TitleBarRightDiv">
                <img id="TitleBarLogo" src="/images/logo-new.svg">
                <a class="fa fa-sign-out" href="/logout"></a>
            </div>
        </div>
        <div id="SideNavigation">
            <a href="#" class="nav-item active">
                <i class="fa fa-inbox" aria-hidden="true"></i>
                <span class="nav-item-label">Inbox</span>
            </a>
        </div>
        <div id="Main">
            <div id="EmailList">
                <div v-for="(email, index) in emails">
                    <div v-if="email.displayed" v-on:click="viewEmail(email, index)" class="email-snippet"
                         :class="extraClasses(index)">
                        <span class="received-label">
                            <i v-if="email.isUnread" class="fa fa-circle" aria-hidden="true"></i>
                            {{ email.messageListDateString(displayStartDateTime) }}
                        </span>
                        <h4>{{ email.from_firstname }} {{ email.from_surname }} <i v-if="email.hasAttachments"
                                                                                   class="fa fa-paperclip"></i></h4>
                        <h5>{{ email.subject }}</h5>
                        <p v-html="email.preview"></p>
                    </div>
                </div>
                <p id="NoEmailsText" v-if="inboxHasEmails === false">No emails to display.</p>
            </div>
            <p v-if="!viewingEmail" id="ClickToViewEmailPrompt">Click on an email in the list to view it.</p>
            <div v-if="viewingEmail" id="EmailView">
                <button v-on:click="stopViewingEmail()" id="BackButton" class="btn btn-brand btn-sm">
                    <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
                    Go Back
                </button>
                <button v-on:click="print()" class="btn btn-brand btn-sm" id="PrintButton">
                    <i class="fa fa-print" aria-hidden="true"></i>
                    Print
                </button>
                <h2 class="email-initials">{{ from_initials }}</h2>
                <div class="email-details">
                    <h3>{{ subject }}</h3>
                    <div class="email-sender-name">{{ from_firstname }} {{ from_surname }}</div>
                    <div class="email-date-time">{{ email_datetime_string }}</div>
                    <div class="email-recipient">To: {{ user.firstname }} {{ user.surname }}</div>
                </div>
                <hr/>
                <div class="email-body">
                    <div class="attachments">
                        <div v-for="attachment in attachments">
                            <a :href="'/inbox/download/' + attachment.md5" class="attachment-wrapper" download>
                                <div class="attachment-link">
                                    <i class="fa fa-file-o" aria-hidden="true"></i>
                                    {{ attachment.filename }}
                                </div>
                                <i class="fa fa-paperclip" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div class="email-content" v-html="content"></div>
                </div>
            </div>
        </div>
        <div id="FooterBar">Items: {{ emailQueue.emailDisplayCount }}</div>
    </div>
</template>

<script>
    var moment = require('moment');
    var Email = require('../objects/Email');
    var EmailQueue = require('../objects/EmailQueue');

    export default {
        name: 'inbox',
        data() {

            let parsedInboxData = this.parseInboxData(this.inboxData);
            let browserTDStamp = moment();
            let serverTimeStamp = moment(this.serverTimestamp);
            let browserOffsetMS = browserTDStamp.diff(serverTimeStamp);
            let scheduleStartDateTime = moment(parsedInboxData.schedule.startDateTime);
            let displayStartDateTime = moment(scheduleStartDateTime);
            let fictitiousStartDateTime = parsedInboxData.fictitiousStartDateTime;
            if (fictitiousStartDateTime !== false) {
                displayStartDateTime = moment(fictitiousStartDateTime);
            }
            let emailQueue = this.buildEmailQueue(
                parsedInboxData.emails,
                browserOffsetMS,
                scheduleStartDateTime
            );

            /**
             * Do an initial update to prepare the email queue for display
             */
            emailQueue.update();

            /**
             * Check if the first email to come through has already been displayed
             * if it hasn't we havent seen any emails yet and can flip this flag on later when receiving emails
             */
            let inboxHasEmails = false;
            if (emailQueue.emails.length > 0) {
                inboxHasEmails = (emailQueue.emails[emailQueue.emails.length - 1].displayed);
            }

            if (this.isNotificationEnabled() === true) {
                Notification.requestPermission();
                this.$on('notification', function (noOfEmails) {
                    if (Notification.permission == 'granted') {
                        new Notification('You have ' + noOfEmails + ' unread emails');
                        new Audio('/sounds/alert.wav').play();
                    }
                });
            }

            return {
                user: parsedInboxData.user,
                scheduleStartDateTime: scheduleStartDateTime,
                displayStartDateTime: displayStartDateTime,
                emails: parsedInboxData.emails,
                content: '',
                from_email: '',
                from_firstname: '',
                from_initials: '',
                from_surname: '',
                subject: '',
                attachments: '',
                email_datetime_string: '',
                serverTimestamp: parsedInboxData.timestamp,
                browserOffsetMS: browserOffsetMS,
                emailQueue: emailQueue,
                activeEmail: '',
                inboxHasEmails: inboxHasEmails,
                viewingEmail: false
            }
        },
        created() {
            this.updateMessageList();
        },
        methods: {
            print() {
                window.print();
            },
            stopViewingEmail() {
                this.viewingEmail = false;
                $("#EmailView").hide();
            },
            /**
             * @return {EmailQueue}
             */
            buildEmailQueue(emailsFromJSON, browserOffsetMS, scheduleStartDateTime) {
                var emails = [];
                for (var i = 0; i < emailsFromJSON.length; i++) {
                    var emailObject = new Email(browserOffsetMS, emailsFromJSON[i]);
                    emails.push(emailObject);
                }
                return new EmailQueue(emails, scheduleStartDateTime);
            },
            updateMessageList() {
                setInterval(function () {
                    try {
                        var hasNewEmails = this.emailQueue.update();
                        if (hasNewEmails === true) {
                            this.inboxHasEmails = true;
                            if (this.isNotificationEnabled() === true) {
                                this.$emit('notification', this.emailQueue.unreadEmailCount);
                            }
                        }
                        this.emails = this.emailQueue.emails;
                    } catch (Error) {
                        console.log('No more emails to display');
                    }
                }.bind(this), 100);
            },
            /**
             * @param {string} inboxData
             * @return {*}
             */
            parseInboxData(inboxData) {
                // If the variable inboxData does not contain the word "user",
                // it has been obfuscated and will need to be decoded before parsing...
                if (inboxData.indexOf('user') === -1) {
                    inboxData = decodeURIComponent(inboxData);
                }
                return JSON.parse(inboxData);
            },
            /**
             * @param {*} email
             * @param {number} index
             */
            viewEmail(email, index) {
                this.content = email.content;
                this.from_email = email.from_email;
                this.from_firstname = email.from_firstname;
                this.from_initials = email.from_initials;
                this.from_surname = email.from_surname;
                this.subject = email.subject;
                this.attachments = email.attachments;
                this.email_datetime_string = email.fullDateString(this.displayStartDateTime);
                this.activeEmail = index;
                this.emailQueue.markEmailAsRead(email);
                this.viewingEmail = true;
                if ($(window).width() <= 768) {
                    $("#EmailView").show();
                }
            },
            /**
             * @param {number} index
             * @return {string}
             */
            extraClasses(index) {
                let classes = [];
                if (this.activeEmail === index) {
                    classes.push('active');
                }
                return classes.join(' ');
            },
            isNotificationEnabled() {
                return typeof Notification != 'undefined';
            },
        },
        computed: {
            /**
             * @return {number}
             */
            emailCount() {
                return this.emails.length;
            },
            /**
             * @return {boolean}
             */
            emailDisplayed() {
                return this.content !== '';
            },
        },
        props: [
            'inboxData'
        ]
    }
</script>


// WEBPACK FOOTER //
// inbox.vue?3fe3c8c1